<div class="wrapper pt-[40px] flex flex-col gap-[40px] flex-1">
  <app-project-reports-list />
  <app-horizontal-date-picker
    (onDateSelection)="handleDateChange($event)"
    [count]="16"
    [date]="date"
    class="date-picker-row"
    />
  @if (consolidatedProjectReport && Object.keys(consolidatedProjectReport).length > 0) {
    <app-consolidated-report [data]="consolidatedProjectReport" />
  } @else {
    <div class="no-data flex justify-start items-center">
      No consolidated report for this day.
    </div>
  }
  <!-- Show workflow actions for project report -->
  @if (projectReport?.id && ('read' | able: projectReport)) {
    <app-workflow
      (actionResponse)="projectReportChanged($event)"
      [id]="projectReport.id"
      [projectId]="projectId"
      [redraw]="projectReport.status"
      wf="project-report-approval"
      />
  }
</div>
